export default __webpack_public_path__ + "static/media/exploded-view_labels.1b507ce0.png";